A partner-provided unique ID for the question choice.

This can be used to correlate the choice back to its corresponding representation in your software.
